import React, { useEffect, useState } from 'react'
import { create, muiDialogV5, useModal } from '@ebay/nice-modal-react'
import { Box, Button, Stack, Typography, styled } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Link from 'next/link'
import Dialog from '../common/Dialog'
import { ReactComponent as WarningIcon } from '@/assets/imgs/warning.svg'

const DialogContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
`

const TextTitle = styled(Typography)`
  font-weight: 700;
  font-size: 32px;
  line-height: 110%;
  color: #ffffff;

  margin-top: 40px;
  @media (max-width: 800px) {
    margin-top: 20px;
  }
`

const Text1 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #ffffff;

  margin-top: 20px;
  @media (max-width: 800px) {
    margin-top: 12px;
  }
`

const CopyWrapper = styled(Box)`
  width: 100%;
  background: #1c1f0c;
  border: 1px solid rgba(191, 255, 11, 0.2);
  padding: 12px 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 20px;
`

const TextAddress = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.9);
  word-break: break-all;

  width: 230px;
`

const CopyButton = styled(Button)`
  background: #bfff0b;
  width: 24px;
  min-width: 24px;
  height: 24px;
  color: black;

  > svg {
    width: 16px;
    height: 16px;
  }

  :hover {
    color: #bfff0b;
  }
  @media (max-width: 800px) {
    margin-left: 20px;
  }
`

const ConfirmButton = styled(Button)`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #000000;

  height: 48px;
  margin-top: 40px;
  @media (max-width: 800px) {
    margin-top: 20px;
    font-size: 14px;
  }
`

const Text2 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.7);
`

const Text3 = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  font-feature-settings: 'ss02' on, 'ss01' on, 'case' on, 'calt' off;
  color: #bfff0b;
`

interface ReservedAddressDialogProps {
  address: string
}

const ReservedAddressDialog = ({ address }: ReservedAddressDialogProps) => {
  const modal = useModal()

  const [showCopied, setShowCopied] = useState(false)

  useEffect(() => {
    if (showCopied) {
      setTimeout(() => {
        setShowCopied(false)
      }, 3000)
    }
  }, [showCopied])

  return (
    <Dialog {...muiDialogV5(modal)}>
      <DialogContent>
        <WarningIcon />

        <TextTitle>Reserved Address</TextTitle>

        <Text1>
          This is the token reserved contract address, please do not transfer directly through the CEX, you will not be
          able to confirm the source of funds, and you will not be responsible for lost funds.
        </Text1>

        <CopyWrapper>
          <TextAddress>{address}</TextAddress>

          {showCopied ? (
            <TextAddress sx={{ color: '#30C65A', width: 'fit-content' }}>✓ Copied</TextAddress>
          ) : (
            <CopyToClipboard
              text={address}
              onCopy={() => {
                setShowCopied(true)
              }}
            >
              <CopyButton>
                <ContentCopyIcon />
              </CopyButton>
            </CopyToClipboard>
          )}
        </CopyWrapper>

        <ConfirmButton fullWidth variant="contained" onClick={modal.hide}>
          I Know
        </ConfirmButton>

        <Stack direction={{ xs: 'column', md: 'row' }} sx={{ mt: { xs: 10, md: 20 } }} alignItems={'center'}>
          <Text2>I don&apos;t have a wallet plug-in,&nbsp;</Text2>
          <Link target="_blank" href={'https://app-hd.multibit.exchange/'}>
            <Text3>HD Wallet Mode →</Text3>
          </Link>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default create(ReservedAddressDialog)
